export const EmailsValidator = (value) => {
  const emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

  let emails = value.split(",");
  for(let email of emails){
    if(!emailRegex.test(email.trim())){
      return false;
    }
  }
  return true;
};




// WEBPACK FOOTER //
// ./src/helpers/validators/emails-validator.js